// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bai{z-index:2147483000!important}.bai button,.bai input,.bai select,.bai textarea{font-family:inherit;line-height:inherit}.bai fieldset{min-width:0}.bai h2,.bai h3,.bai h4,.bai li,.bai p,.bai ul{margin:0;padding:0}.bai ul{list-style:disc}.bai label{font-weight:inherit}", ""]);
// Exports
module.exports = exports;
